import Alpine from 'alpinejs'
import Collapsible from './Collapsible'

// register plugins
Alpine.data('collapsible', Collapsible)

// start Alpine
window.Alpine = Alpine;
window.Alpine.start();